/**
 * パートナー管理者向けマニュアルのコンテンツ定義
 *
 * /org-admin/manual 配下で表示するマニュアル。
 * 通常の /manual とは別系統。partner admin と grant 保有 designer のみがアクセス可。
 * 内容は partner 非依存で、glossary によって serviceName 等が動的に置換される。
 */

import type { ManualSection } from '../index';

export const partnerManualSections: ManualSection[] = [
  {
    id: 'overview',
    contentDir: '.',
    title: '概要',
    pages: [
      { slug: 'overview', titleKey: '', title: 'マニュアルについて' },
    ],
  },
  {
    id: 'getting-started',
    contentDir: '.',
    title: 'はじめに',
    pages: [
      { slug: 'getting-started', titleKey: '', title: 'ログインとアクセス' },
    ],
  },
  {
    id: 'org-admin',
    contentDir: '.',
    title: '管理画面の使い方',
    pages: [
      { slug: 'org-admin-features', titleKey: '', title: '管理画面の機能一覧' },
      { slug: 'attribute-customization', titleKey: '', title: '属性カスタマイズ' },
    ],
  },
  {
    id: 'impersonation',
    contentDir: '.',
    title: '代行アクセス運用',
    pages: [
      { slug: 'impersonation-workflow', titleKey: '', title: '代行アクセスの実運用手順' },
    ],
  },
  {
    id: 'troubleshooting',
    contentDir: '.',
    title: '困ったときは',
    pages: [
      { slug: 'troubleshooting', titleKey: '', title: 'トラブルシューティング' },
    ],
  },
];

// Vite の import.meta.glob で partner 配下の md をすべて静的に取り込む
const partnerModules = import.meta.glob('./*.md', { query: '?raw', import: 'default' });

export async function loadPartnerMarkdown(_contentDir: string, slug: string): Promise<string> {
  const path = `./${slug}.md`;
  const loader = partnerModules[path];
  if (!loader) {
    return `# ページが見つかりません\n\nリクエストされたページ「${slug}」は存在しません。`;
  }
  return (await loader()) as string;
}
